import i18n from "i18next";
import HttpBackend, { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    supportedLngs: ["fr", "en"],
    fallbackLng: "fr",
    ns: [
      "categories",
      "common",
      "communicate",
      "dashboard",
      "formatter",
      "importDeposit",
      "passwordConstraints",
      "pricing",
      "review",
      "reviewCategories",
      "scopes",
      "segments",
      "trackingCampaign",
      "trajectory",
    ],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/client-ui/locales/{{lng}}/client-ui-{{ns}}.json",
    },
    react: {
      useSuspense: false,
    },
  });

i18n.changeLanguage(
  document.getElementById("root")?.getAttribute("lang") ?? "fr"
);

export default i18n;
